import { Formik } from 'formik'
import * as React from 'react'
import * as Yup from 'yup'

import { FieldOuterContainer, FieldContainer } from '../fields'
import { Input } from '../fields/Input'
import { FieldDescription } from './FieldDescription'
import { Label } from './Label'
import { InfoModal } from './modal'
import { SubmitButton } from './SubmitButton'
import { TextView } from './TextView'

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wpisz poprawny e-mail')
    .required('Wpis e-mail'),
})

export class LimitedView extends React.Component<
  {
    title: string
    message: string
    goBackUrl: string
    limitedUrl: string
    limitedBtnLabel: string
    onGoBackToForm?: () => void
    onSubmit: (values, bag) => void
  },
  {}
> {
  render() {
    const { message, title, onSubmit, limitedUrl, limitedBtnLabel } = this.props
    return (
      <>
        <InfoModal title={title} asModal={false} style={{ marginBottom: 50 }}>
          <TextView>{message}</TextView>
          {limitedUrl && limitedBtnLabel && (
            <SubmitButton
              text={limitedBtnLabel}
              variant="white"
              onClick={e => {
                e.preventDefault()
                if (limitedUrl.length > 0) {
                  window.location.href = limitedUrl
                }
              }}
            ></SubmitButton>
          )}
        </InfoModal>
        <Formik
          onSubmit={onSubmit}
          initialValues={{ email: '' }}
          validationSchema={validationSchema}
          render={({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            isSubmitting,
            errors,
            touched,
          }) => {
            const hasError = errors.email && touched.email
            const error = String(errors.email)
            return (
              <form
                onSubmit={e => {
                  e.preventDefault()
                  window.scroll(0, 0)
                  handleSubmit()
                }}
              >
                <FieldOuterContainer>
                  <Label label={'E-mail'} isRequied={true} htmlFor={'email'} />
                  <FieldContainer>
                    <Input
                      id={'email'}
                      type="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      data-has-error={errors.email && touched.email ? '1' : '0'}
                    />
                  </FieldContainer>
                  <FieldDescription
                    description={
                      'Wpisz swój e-mail by być powiadomionym o zwolnionym miejscu'
                    }
                    hasError={false}
                  />

                  {hasError && (
                    <FieldDescription
                      description={error || ''}
                      hasError={true}
                    />
                  )}
                </FieldOuterContainer>

                <SubmitButton
                  disabled={isSubmitting}
                  text={'Wyślij formularz'}
                />
              </form>
            )
          }}
        />
      </>
    )
  }
}
